import Base from "./Base";

class BOM extends Base {
    toObjectWithBOMID(direct_res = false) {
        let bomList = {};
        let res = {};
        if (direct_res.bomList !== undefined &&
            direct_res.bomList.length > 0
        ) {
            direct_res.bomList.map((v) => {
                bomList[v.bomId] = v;
            });
        }
        res.bomList = bomList;
        return res;
    }
}

export default BOM;